import Vue from 'vue'
import axios from 'axios'
import _ from 'lodash'
import * as types from '../mutation-types'
import cart from '../../pages/cart'

// functions
const buildVoucher = voucher => {
  if (voucher.gems_member_voucher) {
    let value = voucher.gems_member_voucher.Price
    let discountType = 'Percentage'
    if (voucher.gems_member_voucher.PresetDiscountID && voucher.gems_member_voucher.preset_discount &&
      parseInt(voucher.gems_member_voucher.preset_discount.ID) === parseInt(voucher.gems_member_voucher.PresetDiscountID)) {
      value = voucher.gems_member_voucher.preset_discount.Amount
      discountType = voucher.gems_member_voucher.preset_discount.Type === 1 ? 'Price' : 'Percentage'
    }
    return {
      voucher_id: voucher.voucher_id,
      member_voucher_id: voucher.id,
      discount_id: voucher.gems_member_voucher.PresetDiscountID,
      discount_type: discountType,
      voucher_value: value,
      voucher_type: voucher.gems_member_voucher.VoucherType,
      expiry_date: voucher.gems_member_voucher.DaysToExpire,
      used: voucher.used,
      restaurant_id: voucher.restaurant_id,
      group_id: voucher.group_id,
      name: voucher.name,
      voucherImage: voucher.gems_member_voucher.VoucherImage,
      pluID: voucher.gems_member_voucher.PLUID,
      posItemID: voucher.gems_member_voucher.POSItemID,
      description: voucher.gems_member_voucher.Description,
      countdown_number: voucher.gems_member_voucher.CountdownNumber,
      countdown_used: voucher.gems_member_voucher.CountdownUsed,
      isRestaurantOpen: 1
    }
  }
  return null
}

const processCheckCart = (items, processedItems, qty) => {
  items.forEach(item => {
    const item2 = item.set_course_items
    const index = processedItems.findIndex(i => i.pluId === item.plu_id)
    if (index === -1) {
      processedItems.push({
        pluId: item.plu_id,
        name: item.name,
        qty: qty || item.quantity
      })
    } else {
      processedItems[index].qty += qty || item.quantity
    }
    if (item2 && item2.length > 0) {
      processCheckCart(item2, processedItems, item.quantity)
    }
  })
}

export const checkViolatePromoCondition = (promoSetting, dineMode, isMember, cartAmount) => {
  if (!(JSON.parse(promoSetting.dine_modes).includes(dineMode)) ||
    (parseInt(promoSetting.member_only) === 1 && !isMember) ||
    cartAmount < parseFloat(promoSetting.min_spend || 0) ||
    (parseInt(promoSetting.use_limit) > 0 && parseInt(promoSetting.use_limit) <= parseInt(promoSetting.used))
  ) return true
  return false
}

export const getViolatePromoConditionMessage = (promoSetting, dineMode, isMember, cartAmount) => {
  let msg = ''
  let mode = ''
  if (dineMode === 0) {
    mode = 'Dine in'
  }
  if (dineMode === 1) {
    mode = 'Takeaway/Self Collect'
  }
  if (dineMode === 2) {
    mode = 'Delivery'
  }
  if (!(JSON.parse(promoSetting.dine_modes).includes(dineMode))) {
    msg += '- This promo code cannot be applied on ' + mode + '<br>'
  }
  if (parseInt(promoSetting.member_only) === 1 && !isMember) {
    msg += '- This promo code is only available for member <br>'
  }

  if (cartAmount < parseFloat(promoSetting.min_spend || 0)) {
    msg += '- Minimum $' + parseFloat(promoSetting.min_spend || 0) + ' to apply this promo code <br>'
  }

  if (parseInt(promoSetting.use_limit) > 0 && parseInt(promoSetting.use_limit) <= parseInt(promoSetting.used)) {
    msg += '- The promo code has been used'
  }
  return msg
}

export const checkViolatePromoItemCondition = (promoItem, itemQty) => {
  const promoSetting = promoItem.promo_setting
  if (promoSetting.max_qty === null || (itemQty > parseInt(promoSetting.max_qty))) return true
  return false
}

// namespaced
export const namespaced = true

// state
export const state = {
  msg: null,
  pickupDate: null,
  pickupTime: null,
  dates: [],
  times: [],
  cart: [],
  cartItemDialog: false,
  vouchers: [],
  discountInfo: {
    bill_voucher_id: '',
    bill_member_voucher_id: '',
    discount_id: '',
    discount_name: '',
    discount_amount: '',
    discount_type: '',
    non_discount: '',
    promo_code: '',
    iorder_promo_discount_id: '',
    iorder_promo_code_id: ''
  },
  guestDetails: {
    name: '',
    email: '',
    country_code: '',
    mobile: ''
  },
  remarks: null
}

// getters
export const getters = {
  cartMsg: state => state.msg,
  pickupDate: state => state.pickupDate,
  pickupTime: state => state.pickupTime,
  dates: state => state.dates,
  times: state => state.times,
  cart: state => state.cart,
  cartItemDialog: state => state.cartItemDialog,
  vouchers: state => state.vouchers,
  discountInfo: state => state.discountInfo,
  discountInfoIsFilled: state => {
    return state.discountInfo.discount_id && parseInt(state.discountInfo.discount_amount || 0) > 0
  },
  guestDetails: state => state.guestDetails,
  guestDetailsStatus: state => {
    let guestDetailsEmpty = true, guestDetailsFilled = true
    Object.keys(state.guestDetails).forEach(key => {
      if (!state.guestDetails[key] || state.guestDetails[key] === '') {
        guestDetailsFilled = false
      }
      if (state.guestDetails[key] && state.guestDetails[key] !== '') {
        guestDetailsEmpty = false
      }
    })
    return {
      isEmpty: guestDetailsEmpty,
      isFilled: guestDetailsFilled
    }
  },
  itemQtyInCart: (state) => (id) => {
    const itemInCart = state.cart.filter(i => parseInt(i.plu_id) === parseInt(id))
    if (itemInCart.length > 0) {
      return itemInCart.map(i => i.quantity).reduce((a, b) => a + b)
    }
    return 0
  },
  cartQty: state => {
    if (!state.cart || state.cart.length === 0) return 0
    return state.cart.map(i => i.quantity).reduce((a, b) => a + b)
  },
  cartAmount: state => {
    if (!state.cart || state.cart.length === 0) return 0
    return state.cart
      .map(i => i.quantity * parseFloat(i.final_price))
      .reduce((a, b) => a + b)
  },
  cartTimeRequired: state => {
    if (!state.cart || state.cart.length === 0) return 0
    return state.cart.map(i => i.quantity * (i.time_required === 0 ? 1 : parseFloat(i.time_required))).reduce((a, b) => a + b)
  },
  cartLimitReached: (state) => (id) => {
    const item = state.cart.findIndex(i => parseInt(i.plu_id) === parseInt(id))
    return item === -1 ? state.cart.length >= 35 : false
  },
  remarks: state => {
    return state.cart && state.remarks ? state.remarks : null
  }
}

// mutations
export const mutations = {
  [types.RESET_CART_DATA] (state) {
    Object.assign(state, {
      msg: null,
      pickupDate: null,
      pickupTime: null,
      dates: [],
      times: [],
      cart: [],
      cartItemDialog: false,
      vouchers: [],
      discountInfo: {
        bill_voucher_id: '',
        bill_member_voucher_id: '',
        discount_id: '',
        discount_name: '',
        discount_amount: '',
        discount_type: '',
        non_discount: '',
        promo_code: '',
        iorder_promo_discount_id: '',
        iorder_promo_code_id: ''
      },
      guestDetails: {
        name: '',
        email: '',
        country_code: '',
        mobile: ''
      },
      remarks: null
    })
  },

  [types.SET_CART_MSG] (state, msg) {
    const msgs = {
      cart: 'Failed to fetch cart data',
      cart2: 'Failed to save cart data',
      cart3: 'Failed to check item availability'
    }
    const message = msg ? (msgs[msg] ? msgs[msg] : msg) : 'Failed to fetch data'
    state.msg = message
  },

  [types.RESET_CART_MSG] (state) {
    state.msg = null
  },

  [types.SET_PICKUP_DATE] (state, payload) {
    state.pickupDate = payload
  },

  [types.RESET_PICKUP_DATE] (state) {
    state.pickupDate = null
  },

  [types.SET_PICKUP_TIME] (state, payload) {
    state.pickupTime = payload
  },

  [types.RESET_PICKUP_TIME] (state) {
    state.pickupTime = null
  },

  [types.SET_DATES] (state, payload) {
    // payload is dates array
    state.dates = payload
  },

  [types.RESET_DATES] (state) {
    state.dates = []
  },

  [types.SET_TIMES] (state, payload) {
    // payload is times array
    state.times = payload
  },

  [types.RESET_TIMES] (state) {
    state.times = []
  },

  [types.SET_REMARKS] (state, payload) {
    state.remarks = payload
  },

  [types.RESET_REMARKS] (state) {
    state.remarks = null
  },

  [types.FETCH_CART] (state, { cart }) {
    state.cart = cart
  },

  [types.RESET_CART] (state) {
    state.cart = []
    state.remarks = null
  },

  [types.ADD_CART_ITEM] (state, newItem) {
    // payload is item
    const inCart = newItem.in_cart
    delete newItem.in_cart
    const i = state.cart.findIndex(item => (parseInt(item.item_id) === parseInt(newItem.item_id)) &&
      (_.isEqual(_.omit(item, ['quantity', 'cart_id']), _.omit(newItem, ['quantity', 'cart_id'])) === true))
    if (i === -1) {
      state.cart.push(newItem)
    } else {
      const qty = (state.cart[i].voucher_id) ? 1 : inCart ? newItem.quantity : state.cart[i].quantity + newItem.quantity
      const item = Object.assign({}, state.cart[i], {
        quantity: qty
      })
      Vue.set(state.cart, i, item)
    }
    console.log(state.cart);
    if(state.cart.length == 1){//选择第一个时
      console.log("add first plu");
      const prefix = window.config.prefix
      //Cookies.set(`${prefix}visit`, now())
    }
  },

  [types.UPDATE_CART_ITEM] (state, payload) {
    // payload is {item, quantity, options, toppings, set_course_items, final_price}
    const options = payload.options ? payload.options : []
    const toppings = payload.toppings ? payload.toppings : []
    const i = state.cart.findIndex(item => parseInt(item.cart_id) === parseInt(payload.item.cart_id))
    const quantity = payload.voucher_id ? 1 : (payload.quantity ? payload.quantity : 1)
    const newItem = {
      ...payload.item,
      quantity: quantity,
      final_price: payload.final_price ? payload.final_price : payload.item.price, // not needed for checkout
      remarks: payload.special_req ? payload.special_req : '',
      modifiers: options.concat(toppings),
      options: options, // not needed for checkout
      toppings: toppings, // not needed for checkout
      set_course_items: payload.set_course_items ? payload.set_course_items : []
    }
    if (_.isEqual(state.cart[i], newItem)) {
      return
    }
    const j = state.cart.findIndex(item => (parseInt(item.item_id) === parseInt(newItem.item_id)) &&
      (parseInt(item.cart_id) !== parseInt(payload.item.cart_id)) &&
      (_.isEqual(_.omit(item, ['quantity', 'cart_id']), _.omit(newItem, ['quantity', 'cart_id'])) === true))
    if (j === -1) {
      Vue.set(state.cart, i, newItem)
    } else {
      const qty = (state.cart[j].voucher_id) ? 1 : state.cart[j].quantity + newItem.quantity
      const item = Object.assign({}, state.cart[j], {
        quantity: qty
      })
      Vue.set(state.cart, j, item)
    }
  },

  [types.REMOVE_CART_ITEM] (state, payload) {
    // payload is cart_id
    state.cart = state.cart.filter(item => parseInt(item.cart_id) !== parseInt(payload))
  },

  [types.SHOW_CART_ITEM_DIALOG] (state) {
    state.cartItemDialog = true
  },

  [types.HIDE_CART_ITEM_DIALOG] (state) {
    state.cartItemDialog = false
  },

  [types.ADD_CART_VOUCHER] (state, newVoucher) {
    // payload is item
    const i = state.vouchers.findIndex(v => parseInt(v.voucher_id) === parseInt(newVoucher.voucher_id))
    if (i === -1) {
      state.vouchers.push(newVoucher)
    }
  },

  [types.REMOVE_CART_VOUCHER] (state, payload) {
    // payload is voucher_id
    state.vouchers = state.vouchers.filter(v => parseInt(v.voucher_id) !== parseInt(payload))
  },

  [types.REMOVE_DISCOUNT_CART_VOUCHER] (state) {
    state.vouchers = state.vouchers.filter(v => parseInt(v.voucher_type) !== 0)
  },

  [types.SET_DISCOUNT_INFO] (state, payload) {
    state.discountInfo = {
      bill_voucher_id: payload.bill_voucher_id,
      bill_member_voucher_id: payload.bill_member_voucher_id,
      discount_id: payload.discount_id,
      discount_name: payload.discount_name,
      discount_amount: payload.discount_amount,
      discount_type: payload.discount_type ? payload.discount_type : 'Percentage',
      non_discount: 0,
      promo_code: payload.promo_code,
      iorder_promo_discount_id: payload.iorder_promo_discount_id ? payload.iorder_promo_discount_id : '',
      iorder_promo_code_id: payload.iorder_promo_code_id ? payload.iorder_promo_code_id : ''
    }
  },

  [types.RESET_DISCOUNT_INFO] (state) {
    state.discountInfo = {
      bill_voucher_id: '',
      bill_member_voucher_id: '',
      discount_id: '',
      discount_name: '',
      discount_amount: '',
      discount_type: '',
      non_discount: '',
      promo_code: '',
      iorder_promo_discount_id: '',
      iorder_promo_code_id: ''
    }
  },

  [types.SET_GUEST_DETAILS] (state, payload) {
    state.guestDetails = {
      name: payload.name,
      email: payload.email,
      country_code: payload.country_code,
      mobile: payload.mobile
    }
  },

  [types.RESET_GUEST_DETAILS] (state) {
    state.guestDetails = {
      name: '',
      email: '',
      country_code: '',
      mobile: ''
    }
  }
}

// actions
export const actions = {
  resetCartData ({ commit, getters, dispatch }) {
    if (getters['discountInfo'].iorder_promo_code_id) {
      dispatch('promo/updatePromoCodeStatusToAvailable', getters['discountInfo'].iorder_promo_code_id, { root: true })
    }
    commit(types.RESET_CART_DATA)
  },

  setPickupDate ({ commit }, payload) {
    commit(types.SET_PICKUP_DATE, payload)
  },

  resetPickupDate ({ commit }) {
    commit(types.RESET_PICKUP_DATE)
  },

  setPickupTime ({ commit, dispatch }, payload) {
    commit(types.SET_PICKUP_TIME, payload)
    dispatch('menu/resetMenuData', null, {root: true})
    dispatch('fetchMenuCats', null, {root: true})
  },

  resetPickupTime ({ commit }) {
    commit(types.RESET_PICKUP_TIME)
  },

  setRemarks ({ commit }, payload) {
    commit(types.SET_REMARKS, payload)
  },

  resetRemarks ({ commit }) {
    commit(types.RESET_REMARKS)
  },

  resetPickupDateTime ({ commit }) {
    commit(types.RESET_PICKUP_DATE)
    commit(types.RESET_PICKUP_TIME)
  },

  async setTimes ({ commit, getters, rootGetters }) {
    const result = await axios.get('/api/date/current')
    const currentTime = result.data
    const times = [] // time array
    const ap = ['AM', 'PM'] // AM-PM
    const takeawayHours = rootGetters['config/takeawayHours']
    const min = takeawayHours.start
    const max = takeawayHours.end
    const start = (currentTime.h >= min) ? currentTime.h : min
    if (start > min && start < max) {
      times.push('Now')
    }
    const interval = (getters.cartQty >= takeawayHours.limit) ? takeawayHours.interval2 : takeawayHours.interval
    // loop to increment the time and push results in array
    for (var i = start * 60 / interval; i <= max * 60 / interval; i++) {
      const tt = i * interval
      if (tt - currentTime.t < interval) return
      const hh = Math.floor(tt / 60) // getting hours of day in 0-24 format
      var mm = (tt % 60) // getting minutes of the hour in 0-55 format
      // pushing data in array in [00:00 - 12:00 AM/PM format]
      times.push(('0' + ((hh === 12) ? 12 : hh % 12)).slice(-2) + ':' + ('0' + mm).slice(-2) + ' ' + ap[Math.floor(hh / 12)])
    }
    commit(types.SET_TIMES, times)
  },

  async fetchCart ({ commit }) {
    commit(types.RESET_CART_MSG)
    try {
      const { data } = await axios.post('/api/cart')
      commit(types.FETCH_CART, { cart: data })
    } catch (e) {
      commit(types.SET_CART_MSG, 'cart')
    }
  },

  async saveCart ({ commit, state }) {
    commit(types.RESET_CART_MSG)
    try {
      await axios.post('/api/cart/save', { cart: state.cart })
    } catch (e) {
      commit(types.SET_CART_MSG, 'cart2')
    }
  },

  resetCart ({ commit }) {
    commit(types.RESET_CART)
  },

  addCartItem ({ commit, state, rootGetters }, payload) {
    // payload is {voucher_id, member_voucher_id, item, quantity, options, toppings, set_course_items, final_price}
    const options = payload.options ? payload.options : []
    const toppings = payload.toppings ? payload.toppings : []
    const quantity = payload.voucher_id ? 1 : payload.quantity
    const newItem = {
      cart_id: state.cart.length === 0 ? 0 : Math.max(...state.cart.map(i => i.cart_id)) + 1, // not needed for checkout
      voucher_id: payload.voucher_id || null,
      member_voucher_id: payload.member_voucher_id || null,
      item_id: payload.item.item_id,
      category_id: payload.item.category_id,
      category_name: payload.item.category_name,
      category_alternate_name: payload.item.category_alternate_name,
      name: payload.item.name,
      alternativeName: payload.item.alternate_name || '',
      portion_size_name: payload.item.portion_size_name || '',
      priceText: payload.item.price_text || '',
      plu_id: payload.item.plu_id,
      price: payload.item.price,
      price_override: payload.item.price_override || null,
      quantity: quantity,
      in_cart: payload.in_cart,
      final_price: payload.final_price || payload.item.price, // not needed for checkout
      tax: payload.item.tax,
      service_charge: payload.item.service_charge,
      remarks: payload.special_req || '',
      time_required: payload.item.time_required || 0,
      tray_count: payload.item.tray_count,
      modifiers: options.concat(toppings),
      options: options, // not needed for checkout
      toppings: toppings, // not needed for checkout
      is_set_meal: payload.item.is_set_meal,
      set_course_items: payload.set_course_items || [],
      non_discount: payload.item.non_discount,
      photo_url: payload.item.photo_url,
      courses: payload.item.courses, // not needed for checkout
      option_groups: payload.item.option_groups, // not needed for checkout
      max_quantity: payload.item.max_quantity || 10, // not needed for checkout
      min_quantity: payload.item.min_quantity || 1, // not needed for checkout
      is_promo: payload.is_promo || payload.item.is_promo || false, // not needed for checkout
      is_auto_preset: payload.is_auto_preset || false, // not needed for checkout
      iorder_promo_item_id: payload.item.iorder_promo_item_id || 0, // not needed for checkout
      iorder_promo_code_id: payload.item.iorder_promo_code_id || 0, // not needed for checkout
      preset_discounts: payload.item.preset_discounts || []
    }
    commit(types.ADD_CART_ITEM, newItem)

    let voucher
    if (payload.member_voucher_id) {
      voucher = rootGetters['voucher/vouchers'].find(c => parseInt(c.id) === parseInt(payload.member_voucher_id))
    } else if (payload.voucher_id) {
      voucher = rootGetters['voucher/vouchers'].find(c => parseInt(c.voucher_id) === parseInt(payload.voucher_id))
    }

    if (voucher) {
      const newVoucher = buildVoucher(voucher)
      commit(types.ADD_CART_VOUCHER, newVoucher)
    }
  },

  addBackCartItem ({ commit, state, rootGetters }, payload) {
    // payload is {voucher_id, member_voucher_id, item, quantity, options, toppings, set_course_items, final_price}
    const options = payload.options ? payload.options : []
    const toppings = payload.toppings ? payload.toppings : []
    const quantity = payload.voucher_id ? 1 : (payload.quantity ? payload.quantity : 1)
    const newItem = {
      cart_id: state.cart.length === 0 ? 0 : Math.max(...state.cart.map(i => i.cart_id)) + 1, // not needed for checkout
      voucher_id: payload.voucher_id || null,
      member_voucher_id: payload.member_voucher_id || null,
      item_id: payload.item_id,
      category_id: payload.category_id,
      category_name: payload.category_name,
      category_alternate_name: payload.category_alternate_name,
      name: payload.name,
      alternativeName: payload.alternateName || '',
      portion_size_name: payload.portion_size_name || '',
      priceText: payload.priceText || '',
      plu_id: payload.plu_id,
      price: payload.price,
      price_override: payload.price_override || null,
      quantity: quantity,
      final_price: payload.final_price || payload.item.price, // not needed for checkout
      tax: payload.tax,
      service_charge: payload.service_charge,
      remarks: payload.remarks || '',
      time_required: payload.time_required || 0,
      tray_count: payload.tray_count,
      modifiers: options.concat(toppings),
      options: options, // not needed for checkout
      toppings: toppings, // not needed for checkout
      is_set_meal: payload.is_set_meal,
      set_course_items: payload.set_course_items || [],
      non_discount: payload.non_discount,
      photo_url: payload.photo_url,
      courses: payload.courses, // not needed for checkout
      option_groups: payload.option_groups, // not needed for checkout
      max_quantity: payload.max_quantity || 10, // not needed for checkout
      min_quantity: payload.min_quantity || 1, // not needed for checkout
      is_promo: payload.is_promo || false // not needed for checkout
    }
    commit(types.ADD_CART_ITEM, newItem)
    if (payload.voucher_id) {
      const voucher = rootGetters['voucher/vouchers'].find(c => parseInt(c.voucher_id) === parseInt(payload.voucher_id))
      const newVoucher = buildVoucher(voucher)
      commit(types.ADD_CART_VOUCHER, newVoucher)
    }
  },

  addMultipleCartItems ({ commit, state }, payload) {
    const maxCartId = state.cart.length === 0 ? 0 : Math.max(...state.cart.map(i => i.cart_id)) + 1
    payload.map((p, index) => {
      p.cart_id = index + maxCartId
      return p
    }).forEach(i => {
      commit(types.ADD_CART_ITEM, i)
    })
  },

  addCartVoucher ({ commit, rootGetters, state, dispatch }, payload) {
    // payload is voucher_id
    const cartVoucher = state.vouchers
    const voucher = rootGetters['voucher/vouchers'].find(c => parseInt(c.voucher_id) === parseInt(payload))
    const newVoucher = buildVoucher(voucher)
    if (cartVoucher.length > 0) {
      for (let i = 0; i < cartVoucher.length; i++) {
        if (cartVoucher[i].voucher_id !== payload) dispatch('removeCartVoucher', cartVoucher[i].voucher_id)
      }
    }
    commit(types.ADD_CART_VOUCHER, newVoucher)
    if (parseInt(newVoucher.voucher_type) === 0) {
      commit(types.SET_DISCOUNT_INFO, {
        bill_voucher_id: newVoucher.voucher_id,
        bill_member_voucher_id: newVoucher.member_voucher_id,
        discount_id: newVoucher.discount_id,
        discount_type: newVoucher.discount_type,
        discount_name: newVoucher.name ? newVoucher.name : '',
        discount_amount: newVoucher.voucher_value,
        promo_code: ''
      })
    }
  },

  removeCartVoucher ({ commit, state }, payload) {
    // payload is voucher_id
    const voucher = state.vouchers.find(v => parseInt(v.voucher_id) === parseInt(payload))
    if (voucher && parseInt(voucher.voucher_type) === 0) {
      commit(types.RESET_DISCOUNT_INFO)
    }
    commit(types.REMOVE_CART_VOUCHER, payload)
  },

  updateCartItem ({ commit }, payload) {
    commit(types.UPDATE_CART_ITEM, payload)
  },

  removeCartItem ({ commit, state }, payload) {
    // payload is cart_id
    const item = state.cart.find(item => parseInt(item.cart_id) === parseInt(payload))
    if (item && item.voucher_id) {
      commit(types.REMOVE_CART_VOUCHER, item.voucher_id)
    }
    commit(types.REMOVE_CART_ITEM, payload)
  },

  showCartItemDialog ({ commit, dispatch }, payload) {
    commit(types.SHOW_CART_ITEM_DIALOG)
    dispatch('menu/setMenuItem', payload, { root: true })
  },

  hideCartItemDialog ({ commit, dispatch }) {
    commit(types.HIDE_CART_ITEM_DIALOG)
    dispatch('menu/resetMenuItem', null, { root: true })
  },

  async fetchTakeawayDates ({ commit, rootGetters, dispatch }) {
    try {
      const { data } = await axios.post('/api/next/days', {
        days: (rootGetters['config/mode'].isTakeaway ? rootGetters['config/takeawayConfig'].advancedDays : rootGetters['config/deliveryConfig'].advancedDays) + 1
      })
      let dates = data
      for (let date of dates) {
        date.hasSlots = await dispatch('checkTakeawayTimes', date.date)
      }
      commit(types.SET_DATES, dates)
    } catch (e) {
      commit(types.RESET_DATES)
    }
  },

  async fetchTakeawayTimes ({ commit, rootGetters }, payload) {
    const rid = parseInt(rootGetters['config/rid']) === 0 ? parseInt(rootGetters['config/rid2']) : parseInt(rootGetters['config/rid'])
    try {
      const params = {
        restaurant_id: rid,
        mode: rootGetters['config/mode'].isDelivery ? 'delivery' : 'takeaway'
      }
      if (payload) {
        params.date = payload
      }
      const { data } = await axios.post('/api/restaurant/takeawaytimes', params)
      commit(types.SET_TIMES, data)
    } catch (e) {
      commit(types.RESET_TIMES)
    }
  },

  async checkTakeawayTimes ({ commit, rootGetters }, payload) {
    const rid = parseInt(rootGetters['config/rid']) === 0 ? parseInt(rootGetters['config/rid2']) : parseInt(rootGetters['config/rid'])
    try {
      const params = {
        restaurant_id: rid,
        mode: rootGetters['config/mode'].isDelivery ? 'delivery' : 'takeaway'
      }
      if (payload) {
        params.date = payload
      }
      const { data } = await axios.post('/api/restaurant/takeawaytimes', params)
      return data.length > 0
    } catch (e) {

    }
  },

  async checkCartItems ({ commit, state, getters, rootState, rootGetters }) {
    commit(types.RESET_CART_MSG)
    try {
      const items = []
      processCheckCart(state.cart, items)
      const { data } = await axios.post('/api/cart/items/status', {
        items: items
      })
      if (data.code === 0) {
        commit(types.SET_CART_MSG, data.msg)
      } else {
        // Check requirement for delivery
        let msg = ''
        if (rootGetters['config/mode'].isDelivery) {
          const deliveryConfig = rootGetters['config/deliveryConfig']
          // 0: No minimum, 1: Minimum items, 2: Minimum price, 3: Minimum items and price
          switch (deliveryConfig.minType) {
            case 1:
              if (getters.cartQty < deliveryConfig.minItems) {
                msg = 'Store requires a minimum of ' + deliveryConfig.minItems + ' items for delivery.'
              }
              break
            case 2:
              if (getters.cartAmount < deliveryConfig.minPrice) {
                msg = 'Store requires a minimum purchase of $' + deliveryConfig.minPrice.toFixed(2) + ' for delivery.'
              }
              if (deliveryConfig.maxPrice !== 0 && getters.cartAmount > deliveryConfig.maxPrice) {
                msg = (deliveryConfig.maxPriceMessage !== '' && deliveryConfig.maxPriceMessage !== null) ? deliveryConfig.maxPriceMessage : 'Exceed maximum purchase of $' + deliveryConfig.maxPrice.toFixed(2) + ' for delivery.'
              }
              break
            case 3:
              if (getters.cartQty < deliveryConfig.minItems && getters.cartAmount < deliveryConfig.minPrice) {
                msg = 'Store requires a minimum of ' + deliveryConfig.minItems + ' items and purchase of $' + deliveryConfig.minPrice.toFixed(2) + ' for delivery.'
              } else if (getters.cartQty < deliveryConfig.minItems) {
                msg = 'Store requires a minimum of ' + deliveryConfig.minItems + ' items for delivery.'
              } else if (getters.cartAmount < deliveryConfig.minPrice) {
                msg = 'Store requires a minimum purchase of $' + deliveryConfig.minPrice.toFixed(2) + ' for delivery.'
              }
              break
          }
          if (msg) {
            commit(types.SET_CART_MSG, msg)
            return
          }
        }
        // Check requirement for promoItems
        const invalidPromoItems = []
        getters.cart.filter(c => c.is_promo).forEach(c => {
          const promoItem = rootState.promo.promoItems.find(p => p.plu_id === c.plu_id)
          if (!promoItem) {
            invalidPromoItems.push(c)
          } else {
            const items = getters.cart.filter(i => {
              return i.is_promo && promoItem.plu_id === i.plu_id
            }).map(i => i.quantity)
            const itemQty = items.length > 0 ? items.reduce((a, b) => a + b) : 0
            if (checkViolatePromoCondition(promoItem.promo_setting, rootGetters['config/mode'].dineMode, rootGetters['member/isMember'], getters.cartAmount) ||
              checkViolatePromoItemCondition(promoItem, itemQty)
            ) invalidPromoItems.push(c)
          }
        })
        if (invalidPromoItems.length > 0) {
          msg = 'The following item(s) does not fulfill the promotion requirements: ' + invalidPromoItems.map(i => i.name).join(', ')
          commit(types.SET_CART_MSG, msg)
          return
        }
      }
    } catch (e) {
      commit(types.SET_CART_MSG, 'cart3')
    }
  },

  setGuestDetails ({ commit }, payload) {
    commit(types.SET_GUEST_DETAILS, payload)
  },

  resetGuestDetails ({ commit }) {
    commit(types.RESET_GUEST_DETAILS)
  },

  setDiscountInfo ({ commit }, payload) {
    commit(types.SET_DISCOUNT_INFO, {
      bill_voucher_id: '',
      bill_member_voucher_id: '',
      discount_id: payload.discount_id,
      discount_name: payload.discount_name,
      discount_amount: payload.discount_amount,
      discount_type: payload.discount_type ? payload.discount_type : 'Percentage',
      non_discount: 0,
      promo_code: payload.promo_code,
      iorder_promo_discount_id: payload.iorder_promo_discount_id ? payload.iorder_promo_discount_id : '',
      iorder_promo_code_id: payload.iorder_promo_code_id ? payload.iorder_promo_code_id : ''
    })
  },

  resetDiscountInfo ({ commit }) {
    commit(types.RESET_DISCOUNT_INFO)
  },

  removeDiscountCartVoucher ({ commit }) {
    commit(types.REMOVE_DISCOUNT_CART_VOUCHER)
  },

  async checkCartDiscountInfo ({ commit, getters, rootGetters }) {
    commit(types.RESET_CART_MSG)
    try {
      const promoCode = getters.discountInfo.promo_code
      if (!promoCode) return
      const timeData = await axios.post('/api/date/pickup', {
        pickup_date: rootGetters['cart/pickupDate'],
        pickup_time: rootGetters['cart/pickupTime']
      })
      const { data } = await axios.post('/api/promo_code/check', {
        restaurant_id: parseInt(rootGetters['config/rid']),
        promo_code: promoCode,
        pickup_datetime: timeData.data
      })
      if (!data.preset_discount || checkViolatePromoCondition(data.preset_discount.promo_setting, rootGetters['config/mode'].dineMode, rootGetters['member/isMember'], getters.cartAmount)) {
        commit(types.SET_CART_MSG, 'The applied discount is no longer valid. Kindly remove it to proceed further.')
      }
    } catch (e) { }
  },

  async checkPickupDate ({ commit, state }) {
    if (state.pickupDate) {
      const { data } = await axios.post('/api/cart/pickup_date/check', {
        pickup_date: state.pickupDate
      })
      if (data === 0) { // if pickup date is past date, reset pickup date and pickup time
        commit(types.RESET_PICKUP_DATE)
        commit(types.RESET_PICKUP_TIME)
        // pick first date
        if (state.dates > 0) {
          commit(types.SET_PICKUP_DATE, state.dates[0].date)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/cart.js